/* eslint-disable */

/**
 * Create styles for `<OrderPage />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OrderPage />` styles
 */
const orderPageStyles = ({ theme }) => ({
  container: {
    height: `100%`,
  },
  rightSidebar: {
    // right sidebar has to be styled specifically for this page as it varies from pure layout2 structure
    [theme.breakpoints.down(`xl`)]: {
      position: 'absolute',
      right: 0,
      top: 156,
      overflowY: `scroll`,
      height: `calc(100vh - 156px)`,
    },
  },
});

export default orderPageStyles;
